import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  MeetingHolidayRequest,
  MeetingHolidayResponse,
  PageResponse,
} from '../models/meeting.model';

@Injectable({ providedIn: 'root' })
export class MeetingHolidayApiService {
  private url = `${environment.apiUrl}api/meeting-holidays`;
  constructor(private http: HttpClient) {}

  list(
    businessId: number,
    page = 0,
    size = 20,
    countryCode?: string
  ): Observable<PageResponse<MeetingHolidayResponse>> {
    let params = new HttpParams()
      .set('businessId', businessId.toString())
      .set('page', page.toString())
      .set('size', size.toString());
    if (countryCode) {
      params = params.set('countryCode', countryCode);
    }
    return this.http.get<PageResponse<MeetingHolidayResponse>>(this.url, {
      params,
    });
  }

  listActive(businessId: number): Observable<MeetingHolidayResponse[]> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<MeetingHolidayResponse[]>(`${this.url}/active`, {
      params,
    });
  }

  getById(id: number, businessId: number): Observable<MeetingHolidayResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<MeetingHolidayResponse>(`${this.url}/${id}`, { params });
  }

  create(body: MeetingHolidayRequest): Observable<MeetingHolidayResponse> {
    return this.http.post<MeetingHolidayResponse>(this.url, body);
  }

  update(
    id: number,
    businessId: number,
    body: MeetingHolidayRequest
  ): Observable<MeetingHolidayResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.put<MeetingHolidayResponse>(`${this.url}/${id}`, body, {
      params,
    });
  }

  delete(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.url}/${id}`, { params });
  }
}
